// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://lnhynrayyxzmxruuvfhr.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImxuaHlucmF5eXh6bXhydXV2ZmhyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDQyNDIzNDcsImV4cCI6MjA1OTgxODM0N30.UPhdNF2G6fF0roL0sJFjnEn7CT_maM-0kHF7tyTwI_c";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);